import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
export class GGHelper {

   /**
    * Use this method to catch the position from the TransformWorld between two objects in two different containers/layers.
    * @param objToSet Uses the  PIXI.DisplayObject's container to remove the it's offset.
    * @param objToMimic PIXI.DisplayObject to copy the position from.
    * @param position — The world origin to calculate from.
    * @returns {PIXI.Point} Mimiced position.
    */
   public static copyLocalPosition(objToSet: PIXI.DisplayObject, objToMimic: PIXI.DisplayObject | undefined, position?: PIXI.Point | undefined): PIXI.Point {
      return <PIXI.Point>objToSet.parent.toLocal(objToSet.parent.position, objToMimic, position);
   }

   public static createSpineAnimation(spineName:string, animationScale:number = 1, xOffSet:number = 0, yOffset:number=0):PIXI.spine.Spine {
      const spineAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(spineName));

      spineAnimation.pivot.set(0.5, 0.5);
      spineAnimation.position.set(0+xOffSet, 0+yOffset);
      spineAnimation.visible = false;
      spineAnimation.name = spineName;
      spineAnimation.scale.y = animationScale;
      spineAnimation.scale.x = animationScale;
      return spineAnimation;
   }

   public static createTimelineSprite(name:string, animationScale:number = 1, xOffSet:number = 0, yOffset:number=0):TimelineSprite {
      const sprite:TimelineSprite = new TimelineSprite(GameResources.getTextures("grenadeFire"));
      sprite.anchor.set(0.5, 0.5);
      sprite.x = xOffSet;
      sprite.y = yOffset;
      sprite.visible = false;
      return sprite;
   }
}